export default {
  EESTI: 'EESTI',
  OTHER: 'OTHER',
};
